export default __webpack_public_path__ + "static/media/ficha.74129653.png";